import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const TooltipContainer = styled.div`
  top: ${props => (props.left ? props.left + "px" : "")};
  left: ${props => (props.top ? props.top + "px" : "")};
  box-shadow: 0px 0px 10px 2.5px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  width: 350px;
  z-index: 500;
`

const Header = styled.div`
  background-color: ${props => (props.tooltipColor ? props.tooltipColor : "#CDCDCD")};
`

const Tooltip = ({
  onCloseTooltip,
  itemSelected,
  tooltipValue,
  tooltipColor,
  clientX,
  clientY,
}) => (
  <TooltipContainer left={clientY} top={clientX} id="tooltip_container">
    <Header tooltipColor={tooltipColor} className="tooltip_header">
      {itemSelected?.title?.toUpperCase()}
      <div className="icon" onClick={onCloseTooltip}>
        <i className="fas fa-times" />
      </div>
    </Header>
    <div className="tooltip_body">
      <div className="value_container">
        <div className="libelle"></div>
        <div className="value">{tooltipValue}</div>
        <div></div>
      </div>
    </div>
  </TooltipContainer>
)

Tooltip.propTypes = {
  onCloseTooltip: PropTypes.func,
  itemSelected: PropTypes.object,
  tooltipValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tooltipColor: PropTypes.string,
  clientX: PropTypes.number,
  clientY: PropTypes.number,
}

Tooltip.defaultProps = {
  onCloseTooltip: () => {},
  itemSelected: {},
  tooltipColor: "",
  tooltipValue: 0,
  clientX: 0,
  clientY: 0,
}

export default Tooltip
